import * as gql from 'gql-query-builder';

export const getAllInspectionRsRepairsQuery = gql.query({
  operation: 'inspectionRsRepairs',
  variables: { take: 1000 },
  fields: ['id', 'repairId', 'name', 'inspectionCategoryId'],
});
